var collapsible_list_pair_rtlignore_default = {
  "container": "hSL-d",
  "title": "UN6yt",
  "viewerContainer": "ByZvg",
  "titleContainer": "APu-w",
  "content": "xIlEG",
  "expandIcon": "picRv",
  "dndIcon": "CEQVC",
  "RTL": "XGYk-",
  "LTR": "SmgoO",
  "itemContainer": "w-4W9",
  "itemContainerViewer": "guMV3",
  "mouseDown": "DZKZD",
  "innerEditor": "Urig0",
  "item": "Z5dMu",
  "floatingAddPluginMenuWrapper": "wDtx6"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
